<template>
    <div class="change-player-button-container">
        <div :class="['change-player-button shadow-active', buttonState]" @contextmenu="stopRightButton($event)" @mousedown="changeState()"  @touchstart="changeState()">
            <div class="text">
                {{__(getCurrentButtonLabel())}}
            </div>
        </div>
        <div :class="['return-to-matchmaking-button', undoState]" @touchend="stopUndoTimer()" @contextmenu="stopRightButton($event)" @touchstart="startUndoTimer()" @mousedown="startUndoTimer($event)"  @mouseup="stopUndoTimer()"><i class="fas fa-undo"></i></div>
        <div :class="['return-to-matchmaking-button', returnState]" @touchend="stopReturnTimer()" @contextmenu="stopRightButton($event)" @touchstart="startReturnTimer()" @mousedown="startReturnTimer($event)"  @mouseup="stopReturnTimer()"><i class="fas fa-door-open"></i></div>
    </div>
</template>
<script>
export default {
    props: [],
    data() {
        return {
            currentPlayer: false,
            playerId: null,
            players: [],
            buttonState: 'next_player',
            returnState: 'return-inactive',
            returnTimer: null,
            undoTimer: null,
            undoState: 'return-inactive',
            sensor: null,
            backupState: null,
        }
    },
    mounted() {
        window.connection.subscribeSensor(this);
        this.update(window.connection.lastSensorUpdate);

        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },

    methods: {
        stopRightButton(e) {
            e.preventDefault()
        },
        update(data) {
            if (data == null) return;
            if (data.players && this.players.length == 0) this.players = data.players

            if (data.sensor !== undefined) {
                this.sensor = data.sensor;
                if (this.sensor == 1 && this.buttonState == "throw_end") {
                    this.buttonState = "sensor_on"
                }
                if (this.sensor == 2 && this.buttonState == "sensor_on") this.buttonState = "next_player";
            }
            if (data.gameState) {
                if (data.action == "nextPlayer" || data.action == null ) {
                    this.currentPlayer = data.gameState.currentPlayer;
                    //prevent double clicking
                    setTimeout(() => {
                        this.buttonState = "active";
                    }, 2000);
                }
                if (data.action == "playerInputSingle" && data.gameState.scores[data.gameState.currentPlayerIndex].singlescores.length == 3) {
                    this.buttonState = "throw_end";
                }
            }
        },
        getCurrentButtonLabel() {
            if (this.buttonState == "active") {
                return "games.button_end_throw";
            }
            if (this.buttonState == "throw_end") {
                return "games.button_change_player";
            }
            if (this.buttonState == "next_player") {
                return "games.button_please_wait";
            }
            if (this.buttonState == "sensor_on") {
                return "games.button_sensor_on";
            }
        },
        changeState() {
            if (this.buttonState == "active") {
                axios.post("/api/sendNumpadCommand", { command: "next_player" }).then((e) => {
                    this.buttonState = "throw_end";
                });
            }
            else if (this.buttonState == "throw_end") {
                axios.post("/api/sendNumpadCommand", { command: "next_player" }).then((e) => {
                });
                this.buttonState = "next_player";
            }
        },
        startReturnTimer() {
            this.returnState = 'return-in-progress'
            this.returnTimer = setTimeout(() => {
                this.returnState = 'return-active'
                axios.post("/gotourl", {url: "/dashboard/"});
            }, 2000);
        },
        stopReturnTimer() {
            this.returnState = 'return-inactive'
            clearTimeout(this.returnTimer);
        },
        startUndoTimer() {
            this.undoState = 'undo-in-progress'
            this.returnTimer = setTimeout(() => {
                this.undoState = 'return-inactive'
                axios.post("/api/sendNumpadCommand", { command: "clear" }).then((e) => {
				this.stopUndoTimer();
                this.buttonState = "active"
			});
            }, 1000);
        },
        stopUndoTimer() {
            this.undoState = 'return-inactive'
            clearTimeout(this.returnTimer);
        }
    }

}
</script>

<style scoped>
    .change-player-button-container {
        height: 75vh;
        width: 100%;
        display: flex;
        margin: auto;
    }
    .change-player-button {
        flex: 1;
        background-color: var(--background-grey-light);
        color: var(--white);
        font-size: 8vw;
        text-align: center;
        display: block;
        margin: auto;
        box-shadow: 0.1em 0.1em 0.1em var(--full);
        cursor: pointer;
        height: 60vh;
        align-items: center;
        display: flex;
    }
    .change-player-button.active {
        background-color: var(--success);
    }
    .change-player-button.throw_end {
        background-color: var(--primary);
    }
    .change-player-button.sensor_on{
        background-color: var(--primary);
    }
    .change-player-button.next_player {
        background-color: var(--background-grey-light);
    }
    .change-player-button .text {
        flex: 1;
    }

    .return-to-matchmaking-button {
        flex: 0;
        color: var(--white);
        font-size: 15vh;
        text-align: center;
        display: block;
        margin: auto;
        line-height: 60vh;
        box-shadow: 0.1em 0.1em 0.1em var(--full);
        cursor: pointer;
        margin-left: 2vw;
        padding: 0 2vw;
    }
    .return-inactive {
        background-color: var(--background-grey-light);
    }
    .return-in-progress {
        background-color: #e0123c;
        transition: background-color 2000ms linear;
    }
    .undo-in-progress {
        background-color: #e0123c;
        transition: background-color 1000ms linear;
    }
    .return-active {
        background-color: var(--success);
    }
</style>
